// Email back to its original dark navy; Other moved off dark grey to purple, since navy and grey were
// too close to tell apart at small checkbox-swatch size.
const seriesColours = ['0, 28, 53', '0, 148, 204', '242, 168, 5', '163, 228, 86', '196, 44, 61', '142, 68, 173'];

export default seriesColours;
